import * as React from "react";
import { ValueProposition } from "components/flexComponents/Hotels/components/ValueProposition";
import { Hotel } from "typings/microserviceModels/hotels-flex-module";

export const HotelAddressDistanceToPoiAndValueProposition = ({
  hotel,
  address,
  distance,
  showDistance,
  isViewCarousel
}: {
  hotel: Hotel;
  address?: string;
  distance?: string;
  showDistance?: boolean;
  isViewCarousel?: boolean;
}) => {
  return (
    <>
      <div className={isViewCarousel ? "uitk-type-300 truncate" : "uitk-type-300"}>
        {showDistance ? distance : address}
      </div>

      <ValueProposition hotel={hotel} />
    </>
  );
};
